import axios from "axios";

export default (config: any) => {
  axios.create({
    withCredentials: true,
  });
  return axios(config);
};
